(function() {
	'use strict';

	angular.module('quantixApp').factory('UserActivityService',
			UserActivityService);

	UserActivityService.$inject = [ '$resource', '$http','$q' ];

	function UserActivityService($resource, $http,$q) {

		//var factory = {};

		var _saveRecentlyViewedCompany = function(userRecentlyViewedCompany) {
			return $http({
				method : 'POST',
				url : 'api/userActivity/saveRecentlyViewedCompany',
				headers : {
					'Content-type' : 'application/json'
				},
				data : userRecentlyViewedCompany
			})
					.success(function(data) {
					})
					.error(
							function(data) {
								console
										.log("Error in save Recently Viewed Company Angular Service"
												+ data);

							});
		}

		var _getCompanyRecentlyViewedList = function(userRecentlyViewedCompany){
			var deferred = $q.defer();
			var url =  'api/userActivity/getCompanyRecentlyViewed';		
			$http.post(url,userRecentlyViewedCompany).then(function(response) {	
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		};

		var _getModuleAndSectionFlag = function(userName){
			var deferred = $q.defer();
			var url = 'api/userActivity/getModuleAndSectionFlag';
			$http.post(url).then(function(response) {	
				deferred.resolve(response.data);


			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		return {
			saveRecentlyViewedCompany:_saveRecentlyViewedCompany,
			getCompanyRecentlyViewedList:_getCompanyRecentlyViewedList,
			getModuleAndSectionFlag : _getModuleAndSectionFlag
		};
	}
})();
